/*
 * Copyright (C) 2012 Minted Inc.
 *
 * All Rights Reserved
 */

M.Model = M.Model || {};
M.Model.Sample = M.Model.Sample || {};

/**
 * @class M.Model.Sample.CustomColors
 *
 */
M.Model.Sample.CustomColors = Backbone.Model.extend({
  defaults: {
    selectedColors: null,
    userColors: null,
    instructions: '',
    sku: null,
    defaultColors: M.CUSTOM_COLORS.DEFAULT_COLORS
  }
});
